'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FileService = function () {
    function FileService($http, appConfig) {
        "ngInject";

        (0, _classCallCheck3.default)(this, FileService);
        this.$http = $http;
        this.appConfig = appConfig;
    }

    (0, _createClass3.default)(FileService, [{
        key: 'getQuotation',
        value: function getQuotation(enquiryQuoteId) {
            var frm = $('#frmPrint');
            frm.attr('action', this.appConfig.apiServiceBaseUri + ('api/file/getquote/' + enquiryQuoteId));
            frm.submit();
        }
    }, {
        key: 'exportVehicles',
        value: function exportVehicles(entityId) {
            var frm = $('#frmPrint');
            frm.attr('action', this.appConfig.apiServiceBaseUri + ('api/vehicle/publish/' + entityId));
            frm.submit();
        }
    }, {
        key: 'getWebLeadFollowUpEmailTemplate',
        value: function getWebLeadFollowUpEmailTemplate(entityId, enquiryId) {
            return this.$http.get(this.appConfig.apiServiceBaseUri + ('api/file/getwebleadfollowupemailtemplate/' + entityId + '/' + enquiryId));
        }
    }, {
        key: 'removeFollowUpImage',
        value: function removeFollowUpImage(enquiryId, fileName) {
            return this.$http.get(this.appConfig.apiServiceBaseUri + ('api/file/remove/followupimage/' + enquiryId + '?fullUrl=' + fileName));
        }
    }]);
    return FileService;
}();

exports.default = FileService;


// WEBPACK FOOTER //
// ./client/app/common/services/file.service.js